var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mainWindowSetting"
  }, [_c('div', {
    staticClass: "mainWindowResolution"
  }, [_c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('commonSetting.resolution')) + " ")]), _c('el-select', {
    attrs: {
      "popper-class": "setResolution"
    },
    on: {
      "change": _vm.updateBitrate
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, _vm._l(_vm.resolutionOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    });
  }), 1)], 1)]), _c('div', {
    staticClass: "mainWindowResolution"
  }, [_c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('commonSetting.framerate')) + " ")]), _c('el-select', {
    attrs: {
      "popper-class": "setResolution"
    },
    on: {
      "change": _vm.updateBitrate
    },
    model: {
      value: _vm.ratesValue,
      callback: function ($$v) {
        _vm.ratesValue = $$v;
      },
      expression: "ratesValue"
    }
  }, _vm._l(_vm.ratesOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": _vm.showDefault(item.value),
        "value": item.value,
        "disabled": _vm.validateFrameRate(_vm.value, item.value)
      }
    });
  }), 1)], 1)]), _c('el-divider'), _c('div', {
    staticClass: "MainWindowBitrate"
  }, [_c('div', {
    staticClass: "bitrate"
  }, [_vm._v(_vm._s(_vm.$t('commonSetting.bitrate')))]), _c('el-slider', {
    attrs: {
      "show-input-controls": false,
      "min": 100,
      "max": _vm.calMaxBitrate
    },
    on: {
      "input": _vm.changeBitrateInputValue
    },
    model: {
      value: _vm.mainWindowBitrate,
      callback: function ($$v) {
        _vm.mainWindowBitrate = $$v;
      },
      expression: "mainWindowBitrate"
    }
  }), _c('el-input', {
    attrs: {
      "maxlength": 5,
      "show-input-controls": false
    },
    on: {
      "change": _vm.changeBirateVal,
      "input": function ($event) {
        _vm.mainWindowBitrate = Number(_vm.mainWindowBitrate);
      }
    },
    model: {
      value: _vm.inputBitrateValue,
      callback: function ($$v) {
        _vm.inputBitrateValue = $$v;
      },
      expression: "inputBitrateValue"
    }
  }), _c('i', {
    staticClass: "kbps"
  }, [_vm._v("kbps")])], 1), _vm.mainWindowType === 'shareScreen' ? _c('div', {
    staticClass: "disabledMainWindowVolume"
  }, [_c('div', {
    staticClass: "bitrate"
  }, [_vm._v(_vm._s(_vm.$t('setting.volume')))]), _c('el-slider', {
    attrs: {
      "show-input-controls": false,
      "disabled": true,
      "min": 0,
      "max": 500
    },
    model: {
      value: _vm.disabledMainWindowVolume,
      callback: function ($$v) {
        _vm.disabledMainWindowVolume = $$v;
      },
      expression: "disabledMainWindowVolume"
    }
  }), _c('el-input', {
    staticClass: "right w_35",
    attrs: {
      "type": "number",
      "disabled": true
    },
    on: {
      "input": function ($event) {
        _vm.mainWindowVolume = Number(_vm.mainWindowVolume);
      }
    },
    model: {
      value: _vm.disabledInputVolume,
      callback: function ($$v) {
        _vm.disabledInputVolume = $$v;
      },
      expression: "disabledInputVolume"
    }
  }), _c('i', {
    staticClass: "kbps"
  }, [_vm._v("%")]), _c('span', {
    staticClass: "hint"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "popper-class": "volumeHint",
      "effect": "dark",
      "content": _vm.$t('setting.volumeHint'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-help2"
  })])], 1)], 1) : _c('div', {
    staticClass: "MainWindowVolume"
  }, [_c('div', {
    staticClass: "bitrate"
  }, [_vm._v(_vm._s(_vm.$t('setting.volume')))]), _c('el-slider', {
    attrs: {
      "show-input-controls": false,
      "min": 0,
      "max": 100
    },
    on: {
      "input": _vm.changeVolumeInputValue
    },
    model: {
      value: _vm.mainWindowVolume,
      callback: function ($$v) {
        _vm.mainWindowVolume = $$v;
      },
      expression: "mainWindowVolume"
    }
  }), _c('el-input', {
    attrs: {
      "type": "number",
      "show-input-controls": false
    },
    on: {
      "change": _vm.changeVolume,
      "input": function ($event) {
        _vm.mainWindowVolume = Number(_vm.mainWindowVolume);
      }
    },
    model: {
      value: _vm.inputVolume,
      callback: function ($$v) {
        _vm.inputVolume = $$v;
      },
      expression: "inputVolume"
    }
  }), _c('i', {
    staticClass: "kbps"
  }, [_vm._v("%")]), _c('span', {
    staticClass: "hint"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "popper-class": "volumeHint",
      "effect": "dark",
      "content": _vm.$t('setting.volumeHint'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-help2"
  })])], 1)], 1), _c('div', {
    staticClass: "MainWindowPipVolume"
  }, [_c('div', {
    staticClass: "bitrate"
  }, [_vm._v(_vm._s(_vm.$t('setting.pipVolume')))]), _c('el-slider', {
    attrs: {
      "show-input-controls": false,
      "min": 0,
      "max": 100
    },
    on: {
      "input": _vm.changePipVolumeInputValue
    },
    model: {
      value: _vm.pipVolume,
      callback: function ($$v) {
        _vm.pipVolume = $$v;
      },
      expression: "pipVolume"
    }
  }), _c('el-input', {
    attrs: {
      "type": "number",
      "show-input-controls": false
    },
    on: {
      "change": _vm.changePipVolume,
      "input": function ($event) {
        _vm.pipVolume = Number(_vm.pipVolume);
      }
    },
    model: {
      value: _vm.inputPipVolume,
      callback: function ($$v) {
        _vm.inputPipVolume = $$v;
      },
      expression: "inputPipVolume"
    }
  }), _c('i', {
    staticClass: "kbps"
  }, [_vm._v("%")]), _c('span', {
    staticClass: "hint"
  }, [_c('el-tooltip', {
    staticClass: "item",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "effect": "dark",
      "content": _vm.$t('setting.volumePipHint'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-help2"
  })])], 1)], 1), _c('div', {
    staticClass: "noteBox"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('setting.note')))]), _c('ul', {
    staticClass: "noteUl"
  }, [_c('li', {
    staticClass: "noteLi"
  }, [_vm._v(_vm._s(_vm.$t('setting.titleNote')))]), _c('li', {
    staticClass: "noteLi"
  }, [_vm._v(_vm._s(_vm.$t('setting.volumeNote1')))]), _c('li', {
    staticClass: "noteLi"
  }, [_vm._v(_vm._s(_vm.$t('setting.volumeNote2')))]), _c('li', {
    staticClass: "noteLi"
  }, [_vm._v(_vm._s(_vm.$t('setting.mainwindowTips')))])])]), _c('div', {
    staticClass: "save"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.submitSetting
    }
  }, [_vm._v(_vm._s(_vm.$t('invite.saveInvite')))])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };